import { useEffect, useContext } from "react";
import { AppContext } from "src/api/AppContext";
import { useHeaderContext } from "src/api/context/HeaderContext";

export default function useAppMain(routeName: string, showBack: boolean) {
  const { setCurrentPageTitle } = useContext(AppContext);
  const { updateHeaderContent, setisBackIcon } = useHeaderContext();

  useEffect(() => {
    setCurrentPageTitle(routeName);
    setisBackIcon(showBack);
    return () => {
      setCurrentPageTitle(undefined);
      updateHeaderContent(null);
    };
  }, []);
}
